export default "https://cdn-static.gokick.com/assets/09fae944e838c54f14fd77486c4f90b3472cb396/images/systolic-smaller.187d7732286412ba55022faa30794641.svg";